/* eslint-disable no-nested-ternary */
/* eslint-disable object-shorthand */
/* eslint-disable radix */
import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { useParams } from 'react-router-dom';
import {
  Alert,
  Avatar,
  Backdrop,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  MenuItem,
  Select,
  Snackbar,
  Stack,
  TextField,
  ToggleButtonGroup,
  styled,
  useMediaQuery,
} from '@mui/material';

import { Container } from '@mui/system';

import {
  doc,
  getDoc,
  updateDoc,
  setDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { LoadingButton } from '@mui/lab';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import ReactQuill from 'react-quill';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import 'react-phone-input-2/lib/bootstrap.css'
import { db, storage } from '../../firebase.config';

import { UserAuth } from '../../context/AuthContext';
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import CustomNumber from '../../components/customNumber';
import CustomButton from '../../components/CustomButton';
import withAuthorization from '../../withAuthorization';
import LucideIcon from '../../components/LucideIcon';
import CustomCard from '../../components/ui/customCard';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ paddingX: 1, paddingY: 5, minHeight: 400 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const params = useParams;

// ----------------------------------------------------------------------
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    margin: theme.spacing(0.5),
    border: 0,
    // background: 'black',
    '&.Mui-disabled': {
      border: 0,
    },
    '&.Mui-selected': {
      border: 0,
      background: '#5E17EB',
      color: 'white',
    },
    '&:not(:first-of-type)': {
      // background: 'red',
      borderRadius: '7px',
    },
    '&:first-of-type': {
      // background: 'black',
      borderRadius: '7px',
    },
  },
}));
//-----------------------------------------------------------------------
function Organisation() {
  const { user } = UserAuth();
  const [value, setValue] = React.useState(0);
  const [organisation, setOrg] = React.useState();
  const [pastEvents, setPastEvents] = React.useState([]);
  const [brouillonEvent, setbrouillonEvent] = React.useState([]);
  const [notReadyEvents, setNotReadyEvents] = React.useState([]);

  const modules = {
    toolbar: [
      // [{ 'font': [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link', 'image'],
      [{ align: [] }, { color: [] }, { background: [] }], // dropdown with defaults from theme
      ['clean'],
    ],
  };

  const formats = [
    // 'font',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'align',
    'color',
    'background',
  ];
  const [desc, setDesc] = React.useState();
  const handleChangeQuill = (content, delta, source, editor) => {
    console.log(editor.getHTML()); // html 사용시
    console.log(JSON.stringify(editor.getContents())); // delta 사용시
    setDesc(editor.getHTML());
  };

  const isMobile = useMediaQuery('(max-width:600px)');

  const helptext = ' Ce champs est requis. Veuillez le saisir!';
  // information generales------------------------
  const [editeInfoGen, setEditInfoGen] = React.useState(false);
  // information de description
  const [statusJur, setStatus] = React.useState();
  const [nomOrganisation, setNomOrg] = React.useState('');
  const [id, setId] = React.useState();
  const [numLic, setNum] = React.useState('');

  // representant legal
  const [nomField, setNom] = React.useState('');
  const [prenomsField, setPrenoms] = React.useState('');
  const [fonctionField, setFonction] = React.useState('');

  // coordonne
  const [num, setContact] = React.useState('');
  const [ville, setVille] = React.useState('');
  const [pays, setPays] = React.useState('');
  const [emailOrg, setEmailOrg] = React.useState('');

  const [certifie, setCert] = React.useState(false);

  // Bio------------------------
  const [editeBio, setEditBio] = React.useState(false);

  // visuel------------------------
  const [editeVisuel, setEditVisuel] = React.useState(false);
  // upload functions
  const [selectedImage, setSelectedImage] = React.useState();
  const [imageUrl, setImageUrl] = React.useState();
  const [selectedBanner, setSelectedBanner] = React.useState();
  const [BannerUrl, setBannerUrl] = React.useState();

  // Links------------------------
  const [editeLinks, setEditLinks] = React.useState(false);
  const [webLink, setWeb] = React.useState();
  const [fbLink, setFb] = React.useState();
  const [instaLink, setInsta] = React.useState();
  const [xLink, setX] = React.useState();
  const [youLink, setYou] = React.useState();
  const [tiktokLink, setTiktok] = React.useState();
  const [msgerLink, setMsger] = React.useState();
  const [wha, setWha] = React.useState();

  // loading
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  // loading

  // snack
  const [openSnack, setOpenSnack] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [msg, setMsg] = React.useState('');

  const handleClose = () => setOpenSnack(false);

  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const docRef0 = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef0);
        console.log(docSnap.data());
        if (docSnap.exists()) {
          console.log(docSnap.data().idOrg);
          setNom(docSnap.data().nom);
          setPrenoms(docSnap.data().prenom);
          setFonction(docSnap.data().fonction);
          // const q = query(collection(db, 'organisations'), where('orgId', '==', docSnap.data().idOrg));
          console.log(docSnap.data())
          const q = doc(db, 'organisations', docSnap.data().idOrg);
          const querySnapshot = await getDoc(q);
          setOrg(querySnapshot);
          if (querySnapshot.exists()) {
            setNomOrg(querySnapshot.data().nomOrg);
            setId(querySnapshot.id);
            setNum(querySnapshot.data().licence);
            setStatus(querySnapshot.data().type);
            setImageUrl(querySnapshot.data().idVisuel);
            setBannerUrl(querySnapshot.data().bannerVisuel);
            setCert(querySnapshot.data().certified);
            setVille(querySnapshot.data().location?.city);
            setPays(querySnapshot.data().location?.country);
            setContact(querySnapshot.data().infoLine?.tel);
            setWeb(querySnapshot.data().links?.web);
            setWha(querySnapshot.data().links?.what);
            setInsta(querySnapshot.data().links?.insta);
            setYou(querySnapshot.data().links?.youtube);
            setFb(querySnapshot.data().links?.facebook);
            setMsger(querySnapshot.data().links?.messenger);
            setTiktok(querySnapshot.data().links?.tiktok);
            setX(querySnapshot.data().links?.x);
          }


          const q2 = doc(db, `organisations/${docSnap.data().idOrg}/links`, `${docSnap.data().idOrg}`);
          const querySnapshot2 = await getDoc(q2);
          if (querySnapshot2.exists()) {
            setWeb(querySnapshot2.data().web);
            setWha(querySnapshot2.data().what);
            setInsta(querySnapshot2.data().insta);
            setYou(querySnapshot2.data().youtube);
            setFb(querySnapshot2.data().facebook);
            setMsger(querySnapshot2.data().messenger);
            setTiktok(querySnapshot2.data().tiktok);
            setX(querySnapshot2.data().x);
            // setInsta(querySnapshot1.data().insta);
          }

          const q3 = doc(db, `organisations/${docSnap.data().idOrg}/Bio`, `${docSnap.data().idOrg}`);
          const querySnapshot3 = await getDoc(q3);
          if (querySnapshot3.exists()) {
            setDesc(querySnapshot3.data().bio)
          }
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [user.uid]);

  React.useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);
  React.useEffect(() => {
    if (selectedBanner) {
      setBannerUrl(URL.createObjectURL(selectedBanner));
    }
  }, [selectedBanner]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // fonction de mise a jour des infos generales
  const update = async () => {
    setLoading(true);

    const statRef = doc(db, `organisations`, `${id}`);
    try {
      await updateDoc(statRef, {
        type: parseInt(statusJur),
        nomOrg: nomOrganisation,
        location: { country: pays.trim(), city: ville.trim() },
        infoLine: { email: null, tel: num },
        updateDate: serverTimestamp(),
        certified: certifie,
      });

      setLoading(false);
      setOpenSnack(true);
      setMsg('Vos modifications ont bien été prise en compte');
      setSeverity('success');
      setEditInfoGen(false)
    } catch (error) {
      console.log(error);
      setLoading(false);
      setOpenSnack(true);
      setMsg('une erreur ');
      setSeverity('error');
    }
  };

  // fonction de mise a jour logo
  const updateLogo = async () => {
    setLoading(true);
    const statRef = doc(db, `organisations`, `${id}`);
    try {
      if (selectedImage) {
        const storageRef = ref(storage, `/organisations/${id}/logo`); // progress can be paused and resumed. It also exposes progress updates. // Receives the storage reference and the file to upload.
        await uploadBytes(storageRef, selectedImage).then((snapshot) => {
          getDownloadURL(snapshot.ref).then(async (downloadURL) => {
            console.log(downloadURL);
            setImageUrl(downloadURL);
            const refCoord = doc(db, `organisations`, `${organisation.id}`);
            const CoordSnap = await getDoc(refCoord);
            if (CoordSnap.exists()) {
              await updateDoc(refCoord, {
                idVisuel: downloadURL,
              });
            } else {
              await setDoc(refCoord, {
                idVisuel: downloadURL,
              });
            }
          });
        });
      }
      if (selectedBanner) {
        const storageRef = ref(storage, `/organisations/${id}/banner`); // progress can be paused and resumed. It also exposes progress updates. // Receives the storage reference and the file to upload.
        await uploadBytes(storageRef, selectedBanner).then((snapshot) => {
          getDownloadURL(snapshot.ref).then(async (downloadURL) => {
            console.log(downloadURL);
            setBannerUrl(downloadURL);
            const refCoord = doc(db, `organisations`, `${organisation.id}`);
            const CoordSnap = await getDoc(refCoord);
            if (CoordSnap.exists()) {
              await updateDoc(refCoord, {
                bannerVisuel: downloadURL,
              });
            } else {
              await setDoc(refCoord, {
                bannerVisuel: downloadURL,
              });
            }
          });
        });
      }
      setEditVisuel(false);
      setLoading(false);
      setOpenSnack(true);
      setMsg('Vos modifications ont bien été prise en compte');
      setSeverity('success');
    } catch (error) {
      console.log(error);
      setLoading(false);
      setOpenSnack(true);
      setMsg('une erreur ');
      setSeverity('error');
    }
  };
  // fonction de mise a jour logo
  const updateLink = async () => {
    setLoading(true);
    try {
      const refCoord = doc(db, `organisations`, `${organisation.id}`);
      // const CoordSnap = await getDoc(refCoord);
      await updateDoc(refCoord, {
        updateDate: serverTimestamp(),
        links: { web: webLink || null, insta: instaLink || null, x: xLink || null, tiktok: tiktokLink || null, youtube: youLink || null, facebook: fbLink || null, what: wha || null, messenger: msgerLink || null },
      });
      setEditVisuel(false);
      setLoading(false);
      setOpenSnack(true);
      setMsg('Vos modifications ont bien été prise en compte');
      setSeverity('success');
    } catch (error) {
      setWeb()
      setInsta()
      setX()
      setTiktok()
      setYou()
      setFb()
      setWha()
      setMsger()
      console.log(error);
      setLoading(false);
      setOpenSnack(true);
      setMsg('une erreur est survenue');
      setSeverity('error');
    }
    setEditLinks(false);
  };

  const updateBio = async () => {
    setLoading(true);
    try {
      const refCoord = doc(db, `organisations/${organisation.id}/Bio`, `${organisation.id}`);
      const CoordSnap = await getDoc(refCoord);
      if (CoordSnap.exists()) {
        await updateDoc(refCoord, {
          bio: desc,
        });
      } else {
        await setDoc(refCoord, {
          bio: desc,
        });
      }
      setEditBio(false);
      setLoading(false);
      setOpenSnack(true);
      setMsg('Vos modifications ont bien été prise en compte');
      setSeverity('success');
    } catch (error) {
      console.log(error);
      setLoading(false);
      setOpenSnack(true);
      setMsg('une erreur ');
      setSeverity('error');
    }
    setEditLinks(false);
  };

  return (
    <Page title="Organisation">
      <Container>
        <Backdrop sx={{ color: '#ffff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <Stack spacing={3}>
          <div
            style={{
              backgroundImage: `url(${BannerUrl || 'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundColor: '#f2f2f2',
              height: '200px',
              width: '100%',
              display: 'flex',
              borderRadius: '7px',
              alignItems: 'center',
            }}
          >
            <div style={{
              backgroundColor: 'rgba(0, 0, 0, 0.40)',
              height: '200px',
              width: '100%',
              display: 'flex',
              padding: 5,
              borderRadius: '7px',
              alignItems: 'center',
            }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="start"
                mb={3}
                spacing={2}
                sx={{
                  width: '100%',
                  padding: 2,
                  marginX: { xs: 1, sm: 5 },
                }}
              >
                <Avatar src={imageUrl || 'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'} sx={{ width: 100, height: 100 }} />
                <Stack direction="column" alignItems="start" justifyContent="center" sx={{ color: 'white', }}>
                  <Typography sx={{ color: 'white', }} variant="h5" gutterBottom>
                    {nomOrganisation}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    Mise a jour le : 5 octobre 2024 233:12
                  </Typography>
                  <Stack direction="row" spacing={2}>
                    <CustomButton type={'primaire'} buttonText={'Preview'} onClick={() => {
                      window.open(`https://choptonticket.com/fr/organisateur/${id}`);
                    }} />
                  </Stack>
                </Stack>
              </Stack>
            </div>

          </div>
          {/** new */}
          <CustomCard
          >
            <Box padding={3}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack>
                  <Typography variant='h5' textAlign="Start">
                    <strong>Informations générales</strong>
                  </Typography>
                  <Typography color={'text.secondary'} variant="body2" textAlign="Start">
                    Ces informations seront utilisé pour vous contacter
                  </Typography>
                </Stack>

                {!editeInfoGen && isMobile ? (

                  <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                    onClick={() => setEditInfoGen(true)}
                    // mobile
                    disableRipple
                    sx={{ border: '1px solid gainsboro' }}
                  >
                    <LucideIcon name='Pencil' />
                  </IconButton>
                ) : !editeInfoGen ? (

                  <CustomButton buttonText='editer' type='secondaire' onClick={() => setEditInfoGen(true)} />
                ) : null}
              </Stack>
              <Box paddingTop={2}>
                {
                  editeInfoGen ?
                    <Stack spacing={3}>
                      <Stack spacing={2}>
                        <Typography variant='subtitle1'>Type *</Typography>
                        <Stack my={2} direction='row' spacing={1}>
                          <Box onClick={() => setStatus(0)} sx={statusJur === 0 ? { bgcolor: '#F5EFFA', border: '2px solid #5E17EB', borderRadius: '10px', cursor: 'pointer' }
                            :
                            { bgcolor: '#f2f2f2', borderRadius: '10px', cursor: 'pointer' }} paddingX={2} paddingY={1.25} >
                            <Typography variant='body2'>Particulier</Typography>
                          </Box>
                          <Box onClick={() => setStatus(1)} sx={statusJur === 1 ? { bgcolor: '#F5EFFA', border: '2px solid #5E17EB', borderRadius: '10px', cursor: 'pointer' }
                            :
                            { bgcolor: '#f2f2f2', borderRadius: '10px', cursor: 'pointer' }} paddingX={2} paddingY={1.25} >
                            <Typography variant='body2'>Entreprise</Typography>
                          </Box>
                        </Stack>
                        <Stack spacing={1} direction='row'>
                          {
                            statusJur !== 0 && <TextField fullWidth placeholder='Nom de l entreprise' value={nomOrganisation} onChange={(e) => setNomOrg(e.target.value)} />
                          }

                        </Stack>
                      </Stack>
                      <Stack spacing={2}>
                        <Typography variant='subtitle1'>Representant legale *</Typography>
                        <Stack spacing={1} direction='row'>

                          <TextField disabled fullWidth placeholder='nom' value={nomField} onChange={(e) => setNom(e.target.value)} />
                          <TextField disabled fullWidth placeholder='prenom' value={prenomsField} onChange={(e) => setPrenoms(e.target.value)} />

                        </Stack>
                      </Stack>
                      <Stack spacing={2}>
                        <Typography variant='subtitle1'>Coordonées *</Typography>
                        <Stack spacing={1} direction='row'>
                          <TextField fullWidth placeholder='Ville' value={ville} onChange={(e) => setVille(e.target.value)} />
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Pays</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Pays"
                              value={pays}
                              onChange={(e) => setPays(e.target.value)}
                            >
                              <MenuItem value="Côte d'Ivoire">Côte d'Ivoire</MenuItem>
                            </Select>
                          </FormControl>
                        </Stack>
                        <Grid container gap={1}>
                          <Grid item xs={12} sm={5.9}>
                            <TextField type='email' disabled={loading} fullWidth placeholder="Email de contact de l'organisation" value={nomField} onChange={(e) => setNom(e.target.value)} />
                          </Grid>
                          <Grid item xs={12} sm={6.0}>
                            <CustomNumber number={num} onNumberChange={(e) => setNum(e)} />
                          </Grid>
                        </Grid>

                      </Stack>
                      <Stack direction='row' alignItems='center' sx={{ p: 2, bgcolor: '#f2f2f2', borderRadius: '7px', marginY: 2 }} dir="ltr">
                        <Checkbox onClick={() => setCert(!certifie)} checked={certifie} />
                        <Typography>je certifie sur l'honneur l'exactitude des informations ci-dessus.</Typography>
                      </Stack>
                      <Box sx={{ p: 3 }} dir="ltr">
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <Stack direction='row' spacing={2} justifyContent='end'>
                              <CustomButton buttonText='Annuler' loading={loading} type='secondaire' onClick={() => setEditInfoGen(false)} />
                              <CustomButton buttonText='Enregistrer' loading={loading} type='primaire' onClick={() => update()} />
                            </Stack>
                          </Grid>
                        </Grid>
                      </Box>
                    </Stack>
                    : !editeInfoGen &&
                      (statusJur ||
                        nomOrganisation !== '' ||
                        nomField !== '' ||
                        prenomsField !== '' ||
                        num !== '' ||
                        ville !== '' ||
                        pays !== '') ? (
                      <Box>
                        <>
                          <Box sx={{ p: 1 }} dir="ltr">
                            <Stack direction="column" spacing={1}>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <LucideIcon name='Building2' />
                                <Typography>
                                  {statusJur === 0
                                    ? 'Particulier'
                                    : statusJur === 1
                                      ? 'Entreprise'
                                      : statusJur === 2
                                        ? 'association'
                                        : null}{' '}
                                  / {nomOrganisation}
                                </Typography>
                              </Stack>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <LucideIcon name='UserRound' />

                                <Typography>
                                  {nomField} {prenomsField}
                                </Typography>
                              </Stack>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <LucideIcon name='MapPin' />

                                <Typography>
                                  {ville} {pays}
                                </Typography>
                              </Stack>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <LucideIcon name='Phone' />
                                <Typography>{num}</Typography>
                              </Stack>
                            </Stack>
                          </Box>
                        </>
                      </Box>
                    ) : null
                }


              </Box>
            </Box>

          </CustomCard>
          {/** new */}

          {/** new */}
          <Box
            sx={{
              height: '100%',
              borderRadius: '7px',
              padding: 3,
              border: '2px solid gainsboro'
            }}
          >

            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Stack>
                <Typography variant='h5' textAlign="Start">
                  <strong>Description</strong>
                </Typography>
                <Typography variant="body2" textAlign="Start">
                  Ces informations seront utilisé en tant que biographie sur votre page organisateur
                </Typography>
              </Stack>
              {!editeBio && isMobile ? (

                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-haspopup="true"
                  onClick={() => setEditBio(true)}
                  // mobile
                  disableRipple
                  sx={{ border: '1px solid gainsboro' }}
                >
                  <LucideIcon name='Pencil' />
                </IconButton>
              ) : !editeBio ? (

                <CustomButton buttonText='editer' type='secondaire' onClick={() => setEditBio(true)} />
              ) : null}

            </Stack>
            <Box paddingTop={2}>
              {
                editeBio ?
                  <Stack spacing={3}>
                    <ReactQuill
                      theme="snow"
                      modules={modules}
                      formats={formats}
                      value={desc}
                      onChange={handleChangeQuill}
                      placeholder="Saisissez une description pour votre evenement ici..."
                    />
                    <Box sx={{ p: 3 }} dir="ltr">
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Stack direction='row' spacing={2} justifyContent='end'>
                            <CustomButton buttonText='Annuler' loading={loading} type='secondaire' onClick={() => setEditBio(false)} />
                            <CustomButton buttonText='Enregistrer' loading={loading} type='primaire' onClick={() => updateBio()} />
                          </Stack>
                        </Grid>
                      </Grid>
                    </Box>
                  </Stack>
                  : !editeBio && desc ? (
                    <Box>
                      <>
                        <Box sx={{ p: 1 }} dir="ltr">
                          <ReactQuill
                            theme="bubble"
                            readOnly
                            formats={formats}
                            value={desc}
                          />
                        </Box>
                      </>
                    </Box>
                  ) : null
              }


            </Box>
          </Box>
          {/** new */}
          <Box
            sx={{
              height: '100%',
              borderRadius: '7px',
              padding: 3,
              border: '2px solid gainsboro'
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Stack>
                <Typography variant='h5' textAlign="Start">
                  <strong>Visuels</strong>
                </Typography>
                <Typography variant="body2" textAlign="Start">
                  Logo et bannière
                </Typography>
              </Stack>

              {!editeVisuel && isMobile ? (

                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-haspopup="true"
                  onClick={() => setEditVisuel(true)}
                  // mobile
                  disableRipple
                  sx={{ border: '1px solid gainsboro' }}
                >
                  <LucideIcon name='Pencil' />
                </IconButton>
              ) : !editeVisuel ? (

                <CustomButton buttonText='editer' type='secondaire' onClick={() => setEditVisuel(true)} />
              ) : null}
            </Stack>
            {editeVisuel ? (
              <Box>
                <>
                  {/* Description organisation */}
                  <Box sx={{ p: 3, bgcolor: '#f2f2f2', borderRadius: '7px', marginY: 2 }} dir="ltr">
                    <Grid alignItems="center" container spacing={3}>
                      <Grid item xs={10} sm={4} md={4}>
                        <Typography variant="subtitle1">Logo</Typography>
                      </Grid>
                    </Grid>

                    <Box sx={{ p: 1 }} dir="ltr">
                      <Grid paddingY={1} alignItems="center" container spacing={3}>
                        <Grid item xs={8} sm={4} md={4}>
                          <Button
                            fullWidth
                            size="medium"
                            sx={{
                              marginTop: 2,
                              textTransform: 'initial',
                              boxShadow: 'none',
                              border: '1px dashed black',
                              color: 'black',
                              backgroundColor: '#f2f2f2',
                              '&:hover': {
                                backgroundColor: '#f2f2f2',
                                color: '#5E17EB',
                                borderColor: '#5E17EB',
                              },
                            }}
                            variant="contained"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              id="select-image"
                              type="file"
                              onChange={(e) => setSelectedImage(e.target.files[0])}
                            />
                            <Stack
                              sx={{
                                justifyContent: 'space-around',
                                alignItems: 'center',
                                padding: 0,
                              }}
                            >
                              {imageUrl ? (
                                <Grid item xs={12} sm={12} md={10} padding={0}>
                                  <Grid container justifyContent="space-around" alignItems="center" padding={0}>
                                    <Grid item xs={12} sm={8} md={6} padding={0}>
                                      <img src={imageUrl} alt={imageUrl} style={{ maxHeight: 300 }} />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              ) : (
                                <Stack
                                  padding={2}
                                  sx={{
                                    justifyContent: 'center',
                                    alignItems: 'center',

                                  }}
                                >
                                  {loading ? (
                                    '... laoding'
                                  ) : (
                                    <>
                                      <Iconify icon="material-symbols:upload" sx={{ width: 30, height: 30, }} />
                                      <Typography textAlign='center' variant='caption'>Cliquer ici pour charger votre fichier</Typography>
                                      <Typography textAlign='center' variant='caption'>Seul les types de fichier .csv, .xsl sont acceptés</Typography>
                                    </>
                                  )}
                                </Stack>
                              )}
                            </Stack>
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                  <Box sx={{ p: 3, bgcolor: '#f2f2f2', borderRadius: '7px', marginY: 2 }} dir="ltr">
                    <Grid alignItems="center" container spacing={3}>
                      <Grid item xs={10} sm={4} md={4}>
                        <Typography variant="subtitle1">Banniere</Typography>
                      </Grid>
                    </Grid>

                    <Box sx={{ p: 1 }} dir="ltr">
                      <Grid paddingY={1} alignItems="center" container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Button
                            fullWidth
                            size="medium"
                            sx={{
                              marginTop: 2,
                              textTransform: 'initial',
                              boxShadow: 'none',
                              border: '1px dashed black',
                              color: 'black',
                              backgroundColor: '#f2f2f2',
                              '&:hover': {
                                backgroundColor: '#f2f2f2',
                                color: '#5E17EB',
                                borderColor: '#5E17EB',
                              },
                            }}
                            variant="contained"
                            component="label"
                          >
                            <input
                              hidden
                              accept="image/*"
                              id="select-image"
                              type="file"
                              onChange={(e) => setSelectedBanner(e.target.files[0])}
                            />
                            <Stack
                              sx={{
                                justifyContent: 'space-around',
                                alignItems: 'center',
                              }}
                            >
                              {BannerUrl ? (
                                <Grid item xs={12} sm={12} md={10}>
                                  <Grid container justifyContent="space-around" fullWidth alignItems="center" padding={0}>
                                    <Grid item xs={12} sm={12} md={12}>
                                      <img src={BannerUrl} alt={BannerUrl} style={{ maxHeight: 350 }} />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              ) : (
                                <Stack
                                  padding={2}
                                  sx={{
                                    justifyContent: 'center',
                                    alignItems: 'center',

                                  }}
                                >
                                  {loading ? (
                                    '... laoding'
                                  ) : (
                                    <>
                                      <Iconify icon="material-symbols:upload" sx={{ width: 30, height: 30, }} />
                                      <Typography textAlign='center' variant='caption'>Cliquer ici pour charger votre fichier</Typography>
                                      <Typography textAlign='center' variant='caption'>Seul les types de fichier .csv, .xsl sont acceptés</Typography>
                                    </>
                                  )}
                                </Stack>
                              )}
                            </Stack>
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                  <Box sx={{ p: 3 }} dir="ltr">
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Stack direction='row' spacing={2} justifyContent='end'>
                          <CustomButton buttonText='Annuler' loading={loading} type='secondaire' onClick={() => setEditVisuel(false)} />
                          <CustomButton buttonText='Enregistrer' loading={loading} type='primaire' onClick={() => updateLogo()} />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                </>
              </Box>
            ) : !editeVisuel && imageUrl ? (
              <Box>
                <>
                  <Box sx={{ p: 1 }} dir="ltr">
                    <Grid paddingY={1} alignItems="center" container spacing={1}>
                      <Grid item xs={2} sm={1} md={1}>
                        <div
                          style={{
                            backgroundImage: `url(${imageUrl})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            height: '80px',
                            display: 'flex',
                            borderRadius: '7px',
                            alignItems: 'center',
                          }}
                        />
                      </Grid>
                      <Grid item xs={10} sm={8} md={8}>
                        <div
                          style={{
                            backgroundImage: `url(${BannerUrl})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            height: '80px',
                            display: 'flex',
                            borderRadius: '7px',
                            alignItems: 'center',
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </>
              </Box>
            ) : null}
          </Box>
          <Box
            sx={{
              height: '100%',
              borderRadius: '7px',
              padding: 3,
              border: '2px solid gainsboro'
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h6" gutterBottom>
                Links
              </Typography>
              {!editeLinks && isMobile ? (

                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-haspopup="true"
                  onClick={() => setEditLinks(true)}
                  // mobile
                  disableRipple
                  sx={{ border: '1px solid gainsboro' }}
                >
                  <LucideIcon name='Pencil' />
                </IconButton>
              ) : !editeLinks ? (

                <CustomButton buttonText='editer' type='secondaire' onClick={() => setEditLinks(true)} />
              ) : null}

            </Stack>
            {editeLinks ? (
              <Box>
                <>
                  {/* site web */}
                  <Box sx={{ p: 3, border: '2px solid gainsboro', borderRadius: '7px', marginY: 2 }} dir="ltr">
                    <Grid alignItems="center" container spacing={3}>
                      <Grid item xs={10} sm={4} md={4}>
                        <Typography variant="subtitle1">Site web</Typography>
                      </Grid>
                    </Grid>
                    <Box sx={{ p: 1 }} dir="ltr">
                      <Grid paddingY={1} alignItems="center" container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                          <TextField
                            value={webLink}
                            label="Site web"
                            type="text"
                            fullWidth
                            onChange={(e) => setWeb(e.target.value)}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                    <LucideIcon name='Globe' />
                                    <Typography>https://</Typography>
                                  </Stack>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                  {/* reseau social & messaging */}
                  <Box dir="ltr">
                    <Grid alignItems="start" container spacing={3}>
                      <Grid item xs={12} sm={6} md={6}>
                        <Box sx={{ p: 3, border: '2px solid gainsboro', borderRadius: '7px', marginY: 2 }}>
                          <Typography variant="subtitle1">Réseaux sociaux</Typography>
                          <Stack direction="column" paddingY={4} spacing={2}>
                            <TextField
                              value={youLink}
                              type="text"
                              fullWidth
                              onChange={(e) => setYou(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                      <LucideIcon name='Youtube' />
                                      <Typography variant='body1'>youtube.com/</Typography>
                                    </Stack>
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <TextField
                              value={fbLink}
                              type="text"
                              fullWidth
                              onChange={(e) => setFb(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                      <LucideIcon name='Facebook' />
                                      <Typography>facebook.com/</Typography>
                                    </Stack>
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <TextField
                              value={instaLink}
                              type="text"
                              fullWidth
                              onChange={(e) => setInsta(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                      <LucideIcon name='Instagram' />
                                      <Typography>instagram.com/</Typography>
                                    </Stack>
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <TextField
                              value={xLink}
                              type="text"
                              fullWidth
                              onChange={(e) => setX(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                      <LucideIcon name='X' />
                                      <Typography>x.com/</Typography>
                                    </Stack>

                                  </InputAdornment>
                                ),
                              }}
                            />
                            <TextField
                              value={tiktokLink}
                              type="text"
                              fullWidth
                              onChange={(e) => setTiktok(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                      <Iconify icon={'ic:baseline-tiktok'} sx={{ width: 25, height: 25 }} />
                                      <Typography>tiktok.com/@</Typography>
                                    </Stack>

                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} sx={{ height: '100%' }}>
                        <Box sx={{ p: 3, border: '2px solid gainsboro', borderRadius: '7px', marginY: 2, height: '100%' }}>
                          <Typography variant="subtitle1">Messagerie</Typography>
                          <Stack direction="column" paddingY={4} spacing={2}>
                            <TextField
                              value={wha}
                              type="text"
                              fullWidth
                              placeholder='WhatsApp'
                              onChange={(e) => setWha(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Iconify icon={'ic:baseline-whatsapp'} sx={{ width: 25, height: 25 }} />
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <TextField
                              value={msgerLink}
                              type="text"
                              fullWidth
                              onChange={(e) => setMsger(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                      <Iconify icon={'mingcute:messenger-line'} sx={{ width: 25, height: 25 }} />
                                      <Typography>m.me/</Typography>
                                    </Stack>

                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box sx={{ p: 3 }} dir="ltr">
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Stack direction='row' spacing={2} justifyContent='end'>
                          <CustomButton buttonText='Annuler' loading={loading} type='secondaire' onClick={() => setEditLinks(false)} />
                          <CustomButton buttonText='Enregistrer' loading={loading} type='primaire' onClick={() => updateLink()} />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                </>
              </Box>
            ) : !editeLinks && (webLink || fbLink || youLink || instaLink || xLink || tiktokLink || wha || msgerLink) ? (
              <Box>
                <>
                  {/*  */}

                  <Box sx={{ p: 1 }} dir="ltr">
                    {webLink && webLink !== '' && (
                      <Box sx={{ p: 1 }}>
                        <Link href={`https://${webLink}`} underline="hover">
                          {webLink}
                        </Link>
                      </Box>
                    )}
                    <Stack direction='row' spacing={1}>
                      {youLink && youLink !== '' && (
                        <IconButton aria-label="delete">
                          <Iconify icon={'mingcute:youtube-line'} sx={{ width: 25, height: 25 }} />
                        </IconButton>
                      )}
                      {fbLink && fbLink !== '' && (
                        <IconButton aria-label="delete">
                          <Iconify icon={'fa-brands:facebook'} sx={{ width: 25, height: 25 }} />
                        </IconButton>
                      )}
                      {instaLink && instaLink !== '' && (
                        <IconButton aria-label="delete">
                          <Iconify icon={'mdi:instagram'} sx={{ width: 25, height: 25 }} />
                        </IconButton>
                      )}
                      {xLink && xLink !== '' && (
                        <IconButton aria-label="delete">
                          <Iconify icon={'pajamas:x'} sx={{ width: 22, height: 22 }} />
                        </IconButton>
                      )}
                      {tiktokLink && tiktokLink !== '' && (
                        <IconButton aria-label="delete">
                          <Iconify icon={'ic:baseline-tiktok'} sx={{ width: 25, height: 25 }} />
                        </IconButton>
                      )}
                      {wha && wha !== '' && (
                        <IconButton aria-label="delete">
                          <Iconify icon={'ic:baseline-whatsapp'} sx={{ width: 25, height: 25 }} />
                        </IconButton>
                      )}
                      {msgerLink && msgerLink !== '' && (
                        <IconButton aria-label="delete">
                          <Iconify icon={'mingcute:messenger-line'} sx={{ width: 25, height: 25 }} />
                        </IconButton>
                      )}
                    </Stack>

                  </Box>

                </>
              </Box>
            ) : null}
          </Box>
        </Stack>

      </Container>
      <Snackbar open={openSnack} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={`${severity}`} sx={{ width: '100%' }}>
          {msg}
        </Alert>
      </Snackbar>
    </Page>
  );
}

export default withAuthorization(Organisation, "manage_org")